import createSvgIcon from "@material-ui/icons/utils/createSvgIcon";
import React from "react";

const ItalicIcon = createSvgIcon(
  <>
    <path d="M4.19691 0V3H6.51571L2.92735 11H0V14H8.39383V11H6.07503L9.66339 3H12.5907V0H4.19691Z" />
  </>,
  "ItalicIcon"
);

export default ItalicIcon;
